<template>
  <MainTab v-if="registration" main-title="Informazioni pacchetto">
    <ContentWrapper>
      <TicketPackage :registration="registration"></TicketPackage>
    </ContentWrapper>
    <router-link :to="{ name: 'events', params: { ticketFilter: 'past', updateRegistrations: true } }">
      <Links class="dea-links--large dea-links--generic-dark-grey">Torna ai corsi</Links>
    </router-link>
  </MainTab>
  <Loader v-else></Loader>
</template>

<script>
import { mapActions } from "vuex";
import Links from "@/components/elements/Links";
import Loader from "@/components/elements/Loader";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import MainTab from "~/components/events/components/MainTab";
import TicketPackage from "~/components/events/components/TicketPackage.vue";

export default {
  name: "EventsPackage",
  components: {
    ContentWrapper,
    MainTab,
    TicketPackage,
    Links,
    Loader,
  },
  data() {
    return {
      registration: undefined,
    };
  },
  mounted() {
    const registrationId = this.$route.params.registration;
    if (registrationId) {
      this.getPackage(registrationId);
    }
  },
  methods: {
    ...mapActions(["fetchBundleData"]),
    async getPackage(id) {
      this.registration = await this.fetchBundleData(id);
    },
  },
};
</script>

<style lang="scss"></style>
